import Sale, { SaleDTO } from '../Sale';

export const convertFromSaleDTO = (dto: SaleDTO): Sale => ({
  id: dto.id,
  storeName: dto.store.name,
  storeNumber: dto.store.storeNumber,
  itemSold: dto.itemSold,
  salesAmount: dto.salesAmount
});
